$(document).ready(function () {
  $.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done(function () {
    quickView();
  });
});

function quickView() {
  $(".quick-view").click(function () {
    if ($('#quick-view').length === 0) {
      $("body").append('<div id="quick-view"><div class="qv-product-images" style="opacity: 0"></div><div class="qv-content"><div class="holder"><h3 class="qv-product-title"></h3><h4 class="qv-product-type"></h4><h5 class="qv-product-price"></h5><h5 class="qv-product-original-price"></h5><hr /><form id="quick-view-add-to-cart"><div class="qv-add-to-cart"><div class="qv-product-options"></div><div class="quantity"><span>Quantity</span><input type="number" class="qv-quantity" name="quantity" value="1" min="1"></div><input type="hidden" name="id" id="selected-variant-id"><button type="submit" class="qv-add-button">Add to Cart</button><div class="qv-add-to-cart-response" style="display:none;"></div></div></form><div class="qv-product-description"></div></div><a class="view-product" href=""><span>View Full Product Details</span></a></div></div>');
    }

    const product_handle = $(this).data('handle');
    $('#quick-view').attr('class', product_handle);

    $.getJSON('/products/' + product_handle + '.js', function (product) {
      const { title, type, description, images, options, variants } = product;
      $('.qv-product-title').text(title);
      $('.qv-product-type').text(type);
      $('.qv-product-description').html(description);
      $('.view-product').attr('href', '/products/' + product_handle);

      // Reset images
      $('.qv-product-images').empty();
      images.forEach((img) => {
        const imgUrl = img.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
        $('.qv-product-images').append(`<div><img src="${imgUrl}" /></div>`);
      });

      $('.qv-product-images').slick({
        dots: false,
        arrows: false,
        respondTo: 'min',
        useTransform: false
      }).css('opacity', '1');

      // Build variant options
      $('.qv-product-options').empty();
      options.forEach((option, i) => {
        const safeClass = option.name.toLowerCase().replace(/\s+/g, '-');
        $('.qv-product-options').append(
          `<div class="option-selection-${safeClass}">
            <span class="option">${option.name}</span>
            <select class="option option-${i}" data-index="${i}"></select>
          </div>`
        );
        option.values.forEach((value) => {
          $(`.option-${i}`).append(`<option value="${value}">${value}</option>`);
        });
      });

      // Set default variant
      const firstAvailable = variants.find(v => v.available);
      if (firstAvailable) {
        updateVariantUI(firstAvailable);
        updateSelectsFromVariant(firstAvailable);
      }
    });

    // Handle variant change
    $(document).off("change", "#quick-view select").on("change", "#quick-view select", function () {
      const selectedOptions = $('#quick-view select').map(function () {
        return $(this).val();
      }).get();

      const handle = $('#quick-view').attr('class');
      $.getJSON('/products/' + handle + '.js', function (product) {
        const matched = product.variants.find(v =>
          v.option1 === selectedOptions[0] &&
          (!v.option2 || v.option2 === selectedOptions[1]) &&
          (!v.option3 || v.option3 === selectedOptions[2])
        );
        if (matched) updateVariantUI(matched);
      });
    });

    // Handle add to cart via form
    $(document).off("submit", "#quick-view-add-to-cart").on("submit", "#quick-view-add-to-cart", function (e) {
      e.preventDefault();

      const variantId = $('#selected-variant-id').val();
      const quantity = parseInt($('.qv-quantity').val(), 10);

      if (!variantId) {
        $('.qv-add-to-cart-response').addClass('error').removeClass('success').html('<b>ERROR:</b> No variant selected.').fadeIn();
        return;
      }

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          id: variantId,
          quantity: quantity
        },
        dataType: 'json',
        success: function () {
          $('.qv-add-to-cart-response')
            .removeClass('error')
            .addClass('success')
            .html('<span>' + $('.qv-product-title').text() + ' has been added to your cart. <a href="/cart">View cart</a></span>')
            .fadeIn().delay(3000).fadeOut();
        },
        error: function (xhr) {
          $('.qv-add-to-cart-response')
            .removeClass('success')
            .addClass('error')
            .html('<b>ERROR:</b> ' + (xhr.responseJSON?.description || 'Please try again.'))
            .fadeIn();
        }
      });
    });

    // Fancybox init
    $.fancybox({
      href: '#quick-view',
      maxWidth: 1040,
      maxHeight: 600,
      fitToView: true,
      width: '75%',
      height: '70%',
      autoSize: false,
      closeClick: false,
      openEffect: 'none',
      closeEffect: 'none',
      afterShow: function () {
        $('#quick-view').css('opacity', '1').fadeIn(function () {
          $('.qv-product-images').addClass('loaded');
        });
      },
      afterClose: function () {
        $('#quick-view').remove();
      }
    });
  });
}

// Helper to update form with selected variant data
function updateVariantUI(variant) {
  const price = (variant.price / 100).toFixed(2);
  const compare = variant.compare_at_price ? (variant.compare_at_price / 100).toFixed(2) : null;

  $('#selected-variant-id').val(variant.id);
  $('.qv-product-price').text(`$${price}`);
  if (compare && compare > price) {
    $('.qv-product-original-price').text(`$${compare}`).show();
  } else {
    $('.qv-product-original-price').hide();
  }

  if (variant.available) {
    $('.qv-add-button').prop('disabled', false).text('Add to Cart');
  } else {
    $('.qv-add-button').prop('disabled', true).text('Sold Out');
  }
}

// Helper to preselect dropdowns from variant
function updateSelectsFromVariant(variant) {
  if (variant.option1) $('.option-0').val(variant.option1);
  if (variant.option2) $('.option-1').val(variant.option2);
  if (variant.option3) $('.option-2').val(variant.option3);
}

$(window).resize(function () {
  if ($('#quick-view').is(':visible')) {
    $('.qv-product-images').slick('setPosition');
  }
});
